export const ROUTES = {
  aboutYou: "/digital-fingerprint/about-you",
  professionalLife: "/digital-fingerprint/your-professional-life",
};
